/** Cloudflare Durable Object location hints we let players choose between. */
export const REGIONS = [
  { id: 'apac-se', name: 'Southeast Asia', hint: 'Hong Kong / Singapore' },
  { id: 'apac-ne', name: 'Northeast Asia', hint: 'Tokyo / Seoul' },
  { id: 'apac', name: 'Asia-Pacific', hint: 'Osaka / Mumbai' },
  { id: 'oc', name: 'Oceania', hint: 'Sydney / Melbourne' },
  { id: 'wnam', name: 'US West', hint: 'Los Angeles / San Jose' },
  { id: 'enam', name: 'US East', hint: 'Virginia / New York' },
  { id: 'sam', name: 'South America', hint: 'São Paulo' },
  { id: 'weur', name: 'Western Europe', hint: 'Frankfurt / London' },
  { id: 'eeur', name: 'Eastern Europe', hint: 'Warsaw / Vienna' },
  { id: 'me', name: 'Middle East', hint: 'Dubai / Tel Aviv' },
  { id: 'afr', name: 'Africa', hint: 'Johannesburg' },
] as const;

export type RegionId = (typeof REGIONS)[number]['id'];

export const isRegionId = (v: unknown): v is RegionId => REGIONS.some((r) => r.id === v);

/** Default placement by the launcher's country when they don't pick; anything else → Cloudflare's "nearest". */
export const COUNTRY_REGION: Record<string, RegionId> = {
  TW: 'apac-se',
  HK: 'apac-se',
  MO: 'apac-se',
  PH: 'apac-se',
  VN: 'apac-se',
};
